<template>
  <div class="HasBeenInvited" ref="HasBeenInvited">
    <div class="header">
      <TopBar :title="title" />
    </div>
    <div class="content-no-data" v-if="loading" :style="{ 'height': getSty() + 'px' }">
      <van-loading size="35" />
    </div>
    <div class="content" :style="{ 'background': list.length === 0 ? 'transparent' : '' }" v-else>
      <div v-if="list.length > 0">
        <div class="card" v-for="(item, index) of list" :key="index">
          <div class="num" @click="getId(item.id)">{{ item.id }}</div>
          <van-image round width='1rem' height='1rem' :src="item.avatarUrl" />
          <div class="nickName" @click="getUserName(item.userName)">{{ item.userName }}</div>
          <div class="date">{{ getDate(item.lastLoginDate) }}</div>
          <div class="status" :class="getStatus(1)">--</div>
        </div>
      </div>
      <div v-else class="content-no-data">
        <van-image width="100" height="100" :src="nodataImg" />
      </div>

    </div>
    <!-- <div style="text-align:center;margin-top: 16px;" v-if="list.length !== 0">
      <van-button @click="getMore" type="primary" size="small">{{ $t("getMore") }}...</van-button> 
    </div> -->
  </div>
</template>

<script>
import { AccountsFriends } from '@/api/api.js';
import { Notify } from 'vant';
import { Toast } from 'vant';
import TopBar from '@/common/top-bar/index.vue'
import img from '@/assets/img/无数据.png'

export default {
  name: 'HasBeenInvited',
  components: {
    TopBar
  },
  data() {
    return {
      nodataImg: img,
      loading: true,
      title: this.$t("helpEarn.friends"),
      list: [],
      pagebar: {
        currentPage: 1,
        pageSize: 30,
        totalPage: 0,
        totalSize: 0,
      }
    }
  },
  methods: {
    getSty() {
      return document.documentElement.clientHeight - 47;
    },
    getDate(item) {
      const dateStr = item.trim().split(" ")
      return dateStr[0]
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    getStatus(item) {
      if (item == 1) {
        return 'status-1'
      } else {
        return 'status-2'
      }
    },
    confirm() { },
    initPage() {
      const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
      const params = {
        id: loginInfo.id,
        userName: "",
        page: this.pagebar.currentPage,
        size: this.pagebar.pageSize
      }
      AccountsFriends(params).then(res => {
        if (res.code === 200) {
          this.list = res.data.list;
          this.pagebar = res.data.pagebar;
          setTimeout(() => {
            this.loading = false
          }, 1000)
        } else {
          Notify({ type: 'danger', message: res.errors[0] });
        }
      })
    },

    getUserName(item) {
      Toast(item);
    },

    getId(item) {
      Toast(item);
    },

    handleScroll(e) {
      if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
        this.getMore();
      }
    },

    getMore() {
      if (this.list.length >= this.pagebar.totalSize) return
      const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
        ++this.pagebar.currentPage
      const params = {
        id: loginInfo.id,
        page: this.pagebar.currentPage,
        size: this.pagebar.pageSize
      }
      AccountsFriends(params).then(res => {
        if (res.code === 200) {
          this.list = [...this.list, ...res.data.list];
          this.pagebar = res.data.pagebar;
        } else {
          this.pagebar.currentPage--;
          Notify({ type: 'danger', message: res.errors[0] });
        }
      })
    }

  },
  mounted() {
    this.initPage();
    this.$refs.HasBeenInvited.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    this.$refs.HasBeenInvited.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style lang="stylus" scoped>
  /deep/.HasBeenInvited{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #F3F3F3;
    .header{
      margin-bottom: .4rem;
    }
    .content{
      background: #ffffff;
      padding: .4rem;
      height: 100%;
      border-radius: 18px 18px 0px 0;
      .card{
        display: flex;
        justify-content :space-between;
        align-items:center;
        padding-bottom: .4rem;
        .nickName{
          overflow:hidden;
          width: 20%;
          white-space:nowrap;
          text-overflow: ellipsis;
        }

        .num{
          width: 20px;
          overflow:hidden;
          white-space:nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .content-no-data{
      background: transparent !important;
      padding: .4rem;
      height: 100%;
      display flex;
      justify-content center;
    }

  }

  .status-1{
    color:#409F53;
  }
  .status-2{
    color: #FF7532;
  }
</style>



// WEBPACK FOOTER //
// src/pages/hasBeenInvited/HasBeenInvited.vue